module.exports = __webpack_public_path__ + "static/media/g-4-e.febb94fd.jpg";